import { render, staticRenderFns } from "./ecSpreadshirtShop.vue?vue&type=template&id=634dbad0&scoped=true&lang=pug&"
import script from "./ecSpreadshirtShop.vue?vue&type=script&lang=js&"
export * from "./ecSpreadshirtShop.vue?vue&type=script&lang=js&"
import style0 from "./ecSpreadshirtShop.vue?vue&type=style&index=0&id=634dbad0&lang=scss&scoped=true&"
import style1 from "./ecSpreadshirtShop.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634dbad0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VProgressCircular: require('/home/runner/work/EC-Website/EC-Website/node_modules/vuetify/lib/components/VProgressCircular/VProgressCircular.js').default,VRow: require('/home/runner/work/EC-Website/EC-Website/node_modules/vuetify/lib/components/VGrid/VRow.js').default,VAlert: require('/home/runner/work/EC-Website/EC-Website/node_modules/vuetify/lib/components/VAlert/VAlert.js').default,VContainer: require('/home/runner/work/EC-Website/EC-Website/node_modules/vuetify/lib/components/VGrid/VContainer.js').default})
